import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatWidget } from './features/chat/containers/chat-widget/chat-widget';

@Component({
  selector: 'bevvi-root',
  imports: [RouterOutlet, ChatWidget],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('bevvi-ai-fe');
}
